import classNames from 'classnames';
import { useContext } from 'react';
import { ICollectionIntegration } from '../../../../../types';
import styles from '../CollectionSettings.module.css';
import { CollectionSettingsIntegrationContext } from '../contextProvider';
import FieldsNotion from './notion';

function Fields() {
  const integration = useContext(CollectionSettingsIntegrationContext);

  const INTEGRATION_COMPONENT = {
    [ICollectionIntegration.NOTION]: <FieldsNotion />,
  };

  return (
    <div
      className={classNames(styles.containerItem, styles.containerWithSidebar, 'pl-6 pt-6 pb-6')}
    >
      <div className={classNames('is-size-4 with-text-color mb-5')}>Fields</div>

      {INTEGRATION_COMPONENT[integration]}
    </div>
  );
}

export default Fields;
